export const AppConfig = {
  site_name: 'Storage Vault',
  title: 'Access Storage',
  description: 'For Storage purpose',
  locale: 'en',
  brand: 'as',
  brand_name: 'accessStorage',
};
